<template>
  <div>
    <v-dialog width="500px" v-model="CardetailsDialog" persistent>
      <v-card color="white">
        <v-toolbar
          dense
          color="blueColorVariant9"
          class="white--text elevation-0"
          >Vehicle Details<v-spacer /><v-btn icon @click="CarDialogEmit(1)"
            ><v-icon small color="white">mdi-close</v-icon></v-btn
          ></v-toolbar
        >
        <div align="center" class="mt-5">
          <h4 class="font-weight-light">
            License Number:
            <div class="font-weight-bold">
              {{ StoreObj.license_plate_number }}
            </div>
          </h4>
          <h4 class="font-weight-light mt-3">
            Vehicle Color:
            <div class="font-weight-bold">{{ StoreObj.vehicle_color }}</div>
          </h4>
          <h4 class="font-weight-light mt-3">
            Brand:
            <div class="font-weight-bold">{{ StoreObj.vehicle_make }}</div>
          </h4>
          <h4 class="font-weight-light mt-3">
            Model:
            <div class="font-weight-bold">{{ StoreObj.vehicle_model }}</div>
          </h4>
          <h4 class="font-weight-light mt-3">
            Year:
            <div class="font-weight-bold">{{ StoreObj.year }}</div>
          </h4>
        </div>
        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="StoreObj.action == 'LandingView'"
            small
            color="blueColorVariant9"
            dark
            @click="CarDialogEmit(2)"
            >View More</v-btn
          >
          <v-btn
            small
            color="white"
            class="black--text"
            dark
            @click="CarDialogEmit(1)"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    CardetailsDialog: Boolean,
    StoreObj: Object,
  },
  data: () => ({}),
  methods: {
    CarDialogEmit(Toggle) {
      this.$emit("clicked", Toggle);
    },
  },
};
</script>
